import firebase from 'firebase/compat/app';

export class FirebaseAuthService {
  /**
   * Store OAuth credentials when user signs in
   */
  private static oauthCredentials: { accessToken?: string; refreshToken?: string } = FirebaseAuthService.loadCredentials();

  /**
   * Enhanced sign-in that captures OAuth tokens
   */
  static async signInWithGoogleAndCaptureTokens(): Promise<firebase.User | null> {
    try {
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.setCustomParameters({ prompt: 'select_account' });
      provider.addScope('https://www.googleapis.com/auth/spreadsheets');
      
      const result = await firebase.auth().signInWithPopup(provider);
      
      // Extract OAuth credentials using the credential property from result
      if (result.credential) {
        const credential = result.credential as any; // Type assertion for access to accessToken
        this.oauthCredentials = {
          accessToken: credential.accessToken || undefined,
          refreshToken: credential.refreshToken || undefined,
        };
        this.saveCredentials();
        console.log('OAuth tokens captured successfully');
      }
      
      return result.user;
    } catch (error) {
      console.error('Error during enhanced sign-in:', error);
      throw error;
    }
  }

  /**
   * Get stored access token
   */
  static getAccessToken(): string | null {
    // Always try to load from memory, fallback to localStorage if needed
    if (!this.oauthCredentials.accessToken) {
      const creds = this.loadCredentials();
      if (creds.accessToken) {
        this.oauthCredentials = creds;
      }
    }
    return this.oauthCredentials.accessToken || null;
  }

  /**
   * Check if we have valid OAuth credentials for Sheets API
   */
  static hasValidSheetsCredentials(): boolean {
    return !!this.oauthCredentials.accessToken;
  }

  /**
   * Clear stored credentials (on sign out)
   */
  static clearCredentials(): void {
    this.oauthCredentials = {};
    localStorage.removeItem('ezrunpbra_oauth');
  }

  private static saveCredentials() {
    localStorage.setItem('ezrunpbra_oauth', JSON.stringify(this.oauthCredentials));
  }

  private static loadCredentials(): { accessToken?: string; refreshToken?: string } {
    try {
      const raw = localStorage.getItem('ezrunpbra_oauth');
      if (raw) return JSON.parse(raw);
      return {};
    } catch {
      return {};
    }
  }
}
